/* eslint-disable react-refresh/only-export-components -- Context hook must be exported alongside provider */
import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

export type PeekEntityType = 'bill' | 'legislator' | 'committee';

export interface PeekState {
  entityType: PeekEntityType;
  entityId: number;
}

interface QuickPeekContextType {
  peekState: PeekState | null;
  openPeek: (entityType: PeekEntityType, entityId: number) => void;
  closePeek: () => void;
}

const QuickPeekContext = createContext<QuickPeekContextType | null>(null);

export function QuickPeekProvider({ children }: { children: ReactNode }) {
  const [peekState, setPeekState] = useState<PeekState | null>(null);

  const openPeek = useCallback((entityType: PeekEntityType, entityId: number) => {
    setPeekState({ entityType, entityId });
  }, []);

  const closePeek = useCallback(() => {
    setPeekState(null);
  }, []);

  return (
    <QuickPeekContext.Provider value={{ peekState, openPeek, closePeek }}>
      {children}
    </QuickPeekContext.Provider>
  );
}

export function useQuickPeek(): QuickPeekContextType {
  const context = useContext(QuickPeekContext);
  if (!context) {
    throw new Error('useQuickPeek must be used within a QuickPeekProvider');
  }
  return context;
}
